import { render, staticRenderFns } from "./LayoutContentIps.vue?vue&type=template&id=536c7c04&scoped=true"
import script from "./LayoutContentIps.vue?vue&type=script&lang=js"
export * from "./LayoutContentIps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c7c04",
  null
  
)

export default component.exports